import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer>

      <div className="footer-container">
        <div className="footer-section footer-company-info">
          <h3>Company Information</h3>
          <div className="company-info-body">
            <p>
              <strong>Observant Security Limited</strong> is a professional security services company
              registered in England and Wales.
            </p>
            <p>
              Company No. <strong>15182797</strong> &nbsp;|&nbsp; VAT No. <strong>503927888</strong>
            </p>
            <p>
              Registered office: Unit A9, Park Lane, Castle Vale, Birmingham, B35 6LJ.
            </p>
            <p>
              ICO Registration No.{' '}
              <a href="https://ico.org.uk/ESDWebPages/Entry/ZB538133" target="_blank" rel="noopener noreferrer">
                ZB538133 ↗
              </a>
            </p>
            <p>
              Accredited by{' '}
              <a href="https://www.alcumus.com/safecontractor" target="_blank" rel="noopener noreferrer">
                SafeContractor ↗
              </a>{' '}
              and a{' '}
              <a href="https://www.constructionline.co.uk/" target="_blank" rel="noopener noreferrer">
                Constructionline Gold Member ↗
              </a>.
            </p>
          </div>
        </div>

        <div className="footer-section footer-policies">
          <h3>Legal &amp; Policies</h3>
          <ul>
            <li><Link to="/policy/public-protection">Public Protection Policy</Link></li>
            <li><Link to="/policy/data-protection">Data Protection Policy</Link></li>
            <li><Link to="/policy/social-media">Social Media Policy</Link></li>
            <li><Link to="/policy/business-continuity">Business Continuity Plan</Link></li>
            <li><Link to="/policy/mission">Our Mission</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
          </ul>
        </div>

        <div className="footer-section footer-contact">
          <h3>Contact Information</h3>
          <div className="contact-details">
            <p><strong>📞 Phone:</strong> <a href="tel:+447446084868">+44 7446 084868</a></p>
            <p><strong>📧 Email:</strong> <a href="mailto:info@observantsecurity.co.uk">info@observantsecurity.co.uk</a></p>
            <p><strong>📍 Address:</strong> Unit A9, Park Lane, Castle Vale, Birmingham, B35 6LJ</p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        {/* UK National Terrorism Threat Level — professional strip */}
        <div className="threat-level-strip">
          <a
            href="https://www.mi5.gov.uk/threats-and-advice/terrorism-threat-levels"
            target="_blank"
            rel="noopener noreferrer"
            className="threat-level-strip-link"
            aria-label="UK National Terrorism Threat Level is currently Severe. Click to view MI5 guidance."
          >
            <span className="tl-label">UK National Terrorism Threat Level</span>
            <span className="tl-divider">|</span>
            <span className="tl-level">SEVERE</span>
            <span className="tl-source">via MI5.gov.uk ↗</span>
          </a>
        </div>

        <div className="social-links-centered">
          <a href="https://www.facebook.com/share/1LczWwa8qa/" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <img src="/Socalmedia Icons/facebook.png" alt="Facebook" className="social-icon-img" loading="lazy" />
          </a>
          <a href="https://www.linkedin.com/company/observant-security-ltd/about/?viewAsMember=true" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <img src="/Socalmedia Icons/linkedin.png" alt="LinkedIn" className="social-icon-img" loading="lazy" />
          </a>
          <a href="https://wa.me/+447925127201" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <img src="/Socalmedia Icons/whattsup.png" alt="WhatsApp" className="social-icon-img" loading="lazy" />
          </a>
          <a href="https://www.instagram.com/observantsecurity" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <img src="/Socalmedia Icons/instagram.png" alt="Instagram" className="social-icon-img" loading="lazy" />
          </a>
        </div>

        <div className="copyright-bar">
          <p>
            &copy; {new Date().getFullYear()} Observant Security Limited. All Rights Reserved.
            {' '}| <Link to="/policy/data-protection">Privacy Policy</Link>
          </p>
          <p className="footer-legal-text">
            Company registered in England and Wales. Company No. 15182797. VAT Registration No. 503927888.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
